import * as angular from 'angular';
import * as moment from 'moment-timezone';

import AutoFocusIfDirective from './aptAutofocusIf.directive';
import AutoFocusManagerDirective from './aptAutofocusManager.directive';
import { AptEmptyContentOverlayMessageDirective } from './aptEmptyContentOverlayMessage.directive';
import AptLoadingIndicatorDirective from './aptLoadingIndicator.directive';
import { AptScrollHistoryDirective } from './aptScrollHistory.directive';
import { AptResultsBreadcrumbComponent } from './aptResultsBreadcrumb.component';
import { CookieManager } from './cookieManager.service';
import { FileDownloadService } from './fileDownload.service';
import FindApplicationPermissionFilter from './findApplicationPermission.filter';
import FindPermissionFilter from './findPermission.filter';
import GridScrollHistoryService from './gridScrollHistory.service';
import LoadingIndicatorDirective from './loadingIndicator.directive';
import LoadingIndicatorService from './loadingIndicator.service';
import NavPathWithToggleValueFilter from './navPathWithToggleValue.filter';
import PromiseTrackerFactory from './promiseTracker.factory';
import SentryErrorHandler from './sentryErrorHandler.factory';
import { SearchResultOptionToggleDirective } from './searchResultOptionToggle.directive';
import StateNameFromIdFilter from './stateNameFromId.filter';
import StatesService from './states.service';
import { timezoneData } from './timezoneData.const';
import UtilService from './util.service';
import FileSizeFilter from './fileSize.filter';
import { SelectFilesPaneComponent } from './selectFilesPane.component';
import { SelectedFileSummaryComponent } from './selectedFileSummary.component';
import { AptAttachedFilesComponent } from './aptAttachedFiles.component';

// @ts-ignore
moment.tz.add(timezoneData);

declare global {
  interface Window {
    __karma__: object;
  }
}

export default angular
  .module('util', [])
  .factory('$exceptionHandler', [
    function () {
      return SentryErrorHandler;
    },
  ])
  .directive('aptAutofocusIf', ['$timeout', AutoFocusIfDirective])
  .directive('aptAutofocusManager', ['$timeout', AutoFocusManagerDirective])
  .directive(
    'aptEmptyContentOverlayMessage',
    AptEmptyContentOverlayMessageDirective,
  )
  .directive('aptScrollHistory', AptScrollHistoryDirective)
  .component('aptResultsBreadcrumb', AptResultsBreadcrumbComponent)
  .service('cookieManager', CookieManager)
  .filter('findApplicationPermission', FindApplicationPermissionFilter)
  .filter('findPermission', FindPermissionFilter)
  .service('GridScrollHistory', GridScrollHistoryService)
  .directive('loadingIndicator', LoadingIndicatorDirective)
  .directive('aptLoadingIndicator', AptLoadingIndicatorDirective)
  .service('LoadingIndicator', LoadingIndicatorService)
  .service('FileDownloadService', FileDownloadService)
  .filter('navPathWithToggleValue', NavPathWithToggleValueFilter)
  .factory('promiseTracker', PromiseTrackerFactory)
  .directive('searchResultOptionToggle', SearchResultOptionToggleDirective)
  .service('states', StatesService)
  .filter('stateNameFromId', StateNameFromIdFilter)
  .service('util', UtilService)
  .filter('fileSizeFilter', FileSizeFilter)
  .component('selectFilesPane', SelectFilesPaneComponent)
  .component('selectedFileSummary', SelectedFileSummaryComponent)
  .component('aptAttachedFiles', AptAttachedFilesComponent).name;
